import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home/home.component'
import { HomeRoutingModule } from './home.routing.module'
import { SharedModule } from '../../shared.module';
import { CommonAppModule } from '../common/common.module';

@NgModule({
  
  imports: [ 
    HomeRoutingModule,
    CommonModule,
    SharedModule,
    CommonAppModule
  ],
  exports: [
  ],
  declarations: [ 
    HomeComponent  
  ],
  providers: [],
})
export class HomeModule { }
